import React, { useState } from "react";
import { FiImage } from "react-icons/fi";

interface ImageUploadPlaceholderProps {
	className?: string;
	hasError?: boolean;
	label?: string;
	onClick: () => void;
	onDrop?: (files: FileList) => void;
}

export const ImageUploadPlaceholder: React.FC<ImageUploadPlaceholderProps> = ({
	hasError = false,
	label,
	onClick,
	onDrop,
	className = "",
}) => {
	const [isDragOver, setIsDragOver] = useState(false);

	const handleDragEnter = (e: React.DragEvent) => {
		e.preventDefault();
		e.stopPropagation();
		if (e.dataTransfer.types.includes("Files")) {
			setIsDragOver(true);
		}
	};

	const handleDragOver = (e: React.DragEvent) => {
		e.preventDefault();
		e.stopPropagation();
	};

	const handleDragLeave = (e: React.DragEvent) => {
		e.preventDefault();
		e.stopPropagation();
		if (
			e.currentTarget === e.target ||
			!e.currentTarget.contains(e.relatedTarget as Node)
		) {
			setIsDragOver(false);
		}
	};

	const handleDrop = (e: React.DragEvent) => {
		e.preventDefault();
		e.stopPropagation();
		setIsDragOver(false);
		if (e.dataTransfer.files?.length && onDrop) {
			onDrop(e.dataTransfer.files);
		}
	};

	return (
		<div
			className={`flex min-h-[155px] max-h-[155px] cursor-pointer items-center justify-center rounded-lg border-2 border-dashed p-4 transition-colors ${
				isDragOver
					? "border-blue-400 bg-blue-50"
					: hasError
						? "border-red-400 bg-red-50"
						: "border-gray-300 bg-gray-50 hover:border-gray-400"
			} ${className}`}
			onClick={onClick}
			onDragEnter={handleDragEnter}
			onDragOver={handleDragOver}
			onDragLeave={handleDragLeave}
			onDrop={handleDrop}
		>
			<div className="flex flex-col items-center gap-1 text-gray-400">
				<FiImage size={30} />
				<span className="text-sm">
					{isDragOver ? "Drop to upload" : "Click or drop to upload"}
				</span>
				{label && <span className="text-xs">{label}</span>}
			</div>
		</div>
	);
};
